// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dn-icon.gw-icon--large{font-size:1.5rem}.gw-icon--success{color:var(--color-highlight-success)}.gw-icon--blue{color:var(--color-primary-fresh)}.gw-icon--title{font-size:var(--font-size-2xl);margin-left:var(--spacing-xs);vertical-align:middle}.gw-icon--text-bottom{vertical-align:text-bottom}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
